"use client";

import type { ReactNode } from "react";

export function renderNode(
  visible: boolean | undefined,
  renderer: ((defaultNode: ReactNode) => ReactNode) | undefined,
  defaultNode: ReactNode,
) {
  if (visible === false) {
    return null;
  }

  return renderer ? renderer(defaultNode) : defaultNode;
}

export function renderItemNode<T>(
  visible: boolean | undefined,
  renderer: ((item: T, defaultNode: ReactNode) => ReactNode) | undefined,
  item: T,
  defaultNode: ReactNode,
) {
  if (visible === false) {
    return null;
  }

  return renderer ? renderer(item, defaultNode) : defaultNode;
}

export function renderWrappedNode<T>(
  item: T,
  defaultNode: ReactNode,
  wrapper: ((item: T, content: ReactNode) => ReactNode) | undefined,
) {
  return wrapper ? wrapper(item, defaultNode) : defaultNode;
}

export function renderGroupNode(
  defaultNode: ReactNode,
  renderer: ((defaultNode: ReactNode) => ReactNode) | undefined,
) {
  return renderer ? renderer(defaultNode) : defaultNode;
}

export function renderCollectionNode<T>(
  items: T[],
  renderItem: (item: T) => ReactNode,
  itemWrapper: ((item: T, content: ReactNode) => ReactNode) | undefined,
  groupRenderer: ((defaultNode: ReactNode) => ReactNode) | undefined,
) {
  const nodes = items.map((item) =>
    renderWrappedNode(item, renderItem(item), itemWrapper),
  );

  return renderGroupNode(nodes, groupRenderer);
}
